export default "__VITE_ASSET__B941iF3C__"